module.exports = __webpack_public_path__ + "img/amanda_falshaw.c26ee157.jpg";